import React from 'react';
import BakingClass from '../../components/BakingClass';
import Menu from '../../components/MenuElements/Menu';
import SubMenu from '../../components/MenuElements/SubMenu';
import Clients from '../../components/common/Clients';
import Timeline from '../../components/common/Timeline';
import Video from '../../components/common/Video';
import AboutUs from '../../containers/AboutUs';
import BlogHome from '../../containers/BlogHome';
import Div from '../../containers/Div';
import HomeSlider02 from '../../containers/HomeSlider02';



const Home02 = () => {
    return (
        <div className="main-wrapper pt_0">
            <HomeSlider02 />
            <AboutUs />
            <Video />
            <Menu />
            <SubMenu />
            <Div />
            <BakingClass />
            <BlogHome />
            <Timeline />
            <Clients />
        </div>
    );
};

export default Home02;